import React, { useState } from "react";
import { useQueryClient } from "react-query";

import {
  ModalShell,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useModal,
} from "components/Modal";
import { Button } from "components/Button";
import { Input } from "components/Input";
import { RegularText } from "components/Text";
import { VerticalSpace } from "components/Spacing";

import { getErrorMessage } from "services/api";

import { createClientTransaction } from "./api";
import styles from "./styles.module.scss";

/** Массовое начисление бонусов выбранным клиентам */
export const AccrueBonusesModal = ({ clients, onDone }) => {
  const queryClient = useQueryClient();
  const { closeModal } = useModal();

  const [bonus, setBonus] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleAccrue = async () => {
    if (!bonus) return;
    setSaving(true);
    setError("");
    try {
      await Promise.all(
        clients.map((client) =>
          createClientTransaction({
            total: bonus,
            comment,
            clientid: client.clientid,
            action: "add",
          })
        )
      );
      queryClient.invalidateQueries(["clients"]);
      onDone?.();
      closeModal();
    } catch (e) {
      setError(getErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <ModalShell width={600}>
      <ModalHeader
        title={`Начислить бонусы массово (${clients.length})`}
        onClose={closeModal}
      />
      <ModalBody className={styles.accrueBody}>
        <Input
          label="Начислить бонусы:"
          labelWidth={140}
          type="number"
          value={bonus}
          onChange={(ev) => setBonus(ev.target.value)}
          inputWidth={120}
        />
        <VerticalSpace size={12} />
        <Input
          label="Комментарий"
          labelWidth={140}
          value={comment}
          onChange={(ev) => setComment(ev.target.value)}
          inputWidth={300}
        />
        {!!error && (
          <>
            <VerticalSpace size={8} />
            <RegularText size={13} color="danger">
              {error}
            </RegularText>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="tertiary" onClick={closeModal}>
          Назад
        </Button>
        <Button
          variant="secondary"
          onClick={handleAccrue}
          disabled={!bonus}
          loading={saving}
        >
          Начислить
        </Button>
      </ModalFooter>
    </ModalShell>
  );
};
